<app-form-modal
  title="Add New Address"
  [(visible)]="visible"
  formId="newAddressForm"
  (cancelForm)="onCancelNewAddressForm()"
  (visibleChange)="onVisibleChange($event)"
  [submitLabel]="
    isVerifyingAddress
      ? 'Verifying Address...'
      : (createAddressState$ | async)?.isLoading
      ? 'Adding Address...'
      : 'Save'
  "
  [disabled]="isVerifyingAddress"
>
  <app-message *ngIf="(createAddressState$ | async)?.error" severity="error" data-cy="create-address-error-message">
    {{ (createAddressState$ | async)?.error?.uiMessage }}
  </app-message>
  <form
    [formGroup]="newAddressForm"
    (ngSubmit)="onSubmitNewAddressForm()"
    id="newAddressForm"
    data-cy="new-address-form"
  >
    <app-form-field
      [control]="asFormControl(newAddressForm.get('line1'))"
      name="line1"
      label="Address 1"
      type="input"
    ></app-form-field>
    <app-form-field
      [control]="asFormControl(newAddressForm.get('line2'))"
      name="line2"
      label="Address 2"
      type="input"
    ></app-form-field>
    <app-form-field
      [control]="asFormControl(newAddressForm.get('attention'))"
      name="attention"
      label="Attention"
      type="input"
    ></app-form-field>
    <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
      <app-form-field
        class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
        [control]="asFormControl(newAddressForm.get('city'))"
        name="city"
        label="City"
        type="input"
      ></app-form-field>
      <app-form-field
        class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
        [control]="asFormControl(newAddressForm.get('state'))"
        name="state"
        label="State"
        type="dropdown"
        [options]="(usStateOptions$ | async) || []"
        placeholder="Select State"
      ></app-form-field>
      <app-form-field
        class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
        [control]="asFormControl(newAddressForm.get('zipCode'))"
        name="zipCode"
        label="Zip Code"
        type="input"
      ></app-form-field>
    </div>
    <app-form-field
      [control]="asFormControl(newAddressForm.get('types'))"
      name="types"
      [options]="getNewAddressTypeOptions()"
      type="checkbox"
    ></app-form-field>
  </form>
</app-form-modal>

<app-form-modal
  title="USPS Address Correction"
  [(visible)]="displayVerificationModal"
  formId="addressVerificationForm"
  (cancelForm)="onCancelAddressVerificationForm()"
  [submitLabel]="(createAddressState$ | async)?.isLoading ? 'Adding Address...' : 'Use Address'"
  [disabled]="(createAddressState$ | async)?.isLoading"
  cancelLabel="Go back"
>
  <form
    [formGroup]="addressVerificationForm"
    (ngSubmit)="onSubmitAddressVerificationForm()"
    id="addressVerificationForm"
    data-cy="address-verification-form"
  >
    <div *ngFor="let option of addressVerificationOptions; let i = index">
      <app-radio-button-card
        [control]="asFormControl(addressVerificationForm.get('selectedAddressFormat'))"
        name="selectedAddressFormat"
        [value]="option.format"
        [ariaLabel]="option.title"
        [isSelected]="!!(option.format === addressVerificationForm.get('selectedAddressFormat')?.value)"
        [handleSelect]="changeSelectedAddressFormat.bind(this, option.format)"
      >
        <div class="pl-1 -mt-1 text-black-400">
          <p class="p3 mt-0 mb-1 font-semibold">
            {{ option.title }}
          </p>
          <p class="p3 font-light my-0 mb-2" [innerHTML]="option.address | formatAddress" data-cy="address-format"></p>
        </div>
      </app-radio-button-card>
    </div>
  </form>
</app-form-modal>

<app-address-orders-form
  [(visible)]="displayAddressOrdersModal"
  successMessageServiceKey="profileMessages"
></app-address-orders-form>
